
import { defineComponent } from 'vue'
import DatasetCard from './GisDocumentDesignerDataset.vue'
import LayersCard from './GisDocumentDesignerLayer.vue'
import LayerFilters from './GisDocumentDesignerLayerFilters.vue'

export default defineComponent({
    components: {
        DatasetCard,
        LayersCard,
        LayerFilters
    },
    emits: [],
    props: { documentDataProp: { type: Object as any, required: true }, allLayers: Array, isDatasetChosen: Boolean },
    computed: {},
    data() {
        return {}
    },
    created() {},
    methods: {}
})
